import React from 'react';
import cx from 'classnames';
import { isInternalURL, flattenToAppURL } from '@plone/volto/helpers/Url/Url';

const ViewLink = ({ url, mode, children }) => {
  const isPDF = url && /(\.pdf($|\?)|\.pdf\/|\.pdf\?)/i.test(url);

  let displayURL = url;

  if (isPDF) {
    displayURL = url
      .replace('/@@download/file', '/@@display-file/file')
      .replace('/@@download', '/@@display-file');

    return mode === 'view' ? (
      <a href={displayURL} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ) : (
      <a href={displayURL}>{children}</a>
    );
  }

  return <a href={url}>{children}</a>;
};

export const LinkElement = (props) => {
  const { attributes, children, element, mode = 'edit' } = props;

  const linkUrl =
    element.data?.url ||
    element.data?.href ||
    element.url ||
    element.href ||
    '';

  const isInternalUrl = isInternalURL(linkUrl);

  return mode === 'view' ? (
    <ViewLink url={linkUrl} mode={mode}>
      {children}
    </ViewLink>
  ) : (
    <a
      {...attributes}
      className={cx('slate-editor-link', { external: !isInternalUrl })}
      href={isInternalUrl ? flattenToAppURL(linkUrl) : linkUrl}
      onClick={(e) => e.preventDefault()}
    >
      {children}
    </a>
  );
};
